import * as React from 'react';
import type { SVGProps } from 'react';
const SvgCompressPowerpoint = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 54 64"
    {...props}
  >
    <rect
      width={53}
      height={63}
      x={0.5}
      y={0.5}
      fill="#fff"
      stroke="#E5E6EB"
      rx={4.5}
    />
    <rect width={38} height={16} x={8} y={44} fill="#FF7A00" rx={3} />
    <path
      fill="#fff"
      d="M17.778 48.789q.693 0 1.22.286.529.285.815.814.297.517.297 1.199 0 .67-.297 1.188t-.847.803q-.54.275-1.254.275h-1.76q-.055 0-.055.055v2.959q0 .056-.044.099a.12.12 0 0 1-.088.033h-1.012a.16.16 0 0 1-.1-.033.16.16 0 0 1-.032-.099v-7.447q0-.055.033-.088a.14.14 0 0 1 .099-.044zm-.187 3.531q.56 0 .902-.33.34-.33.34-.869 0-.55-.34-.891t-.902-.341h-1.64q-.054 0-.054.055v2.321q0 .055.055.055zm6.729-3.531q.693 0 1.22.286.529.285.815.814.297.517.297 1.199 0 .67-.297 1.188t-.847.803q-.54.275-1.254.275h-1.76q-.055 0-.055.055v2.959q0 .056-.044.099a.12.12 0 0 1-.088.033h-1.012a.16.16 0 0 1-.1-.033.16.16 0 0 1-.032-.099v-7.447q0-.055.033-.088a.14.14 0 0 1 .099-.044zm-.187 3.531q.56 0 .902-.33.34-.33.34-.869 0-.55-.34-.891-.341-.34-.902-.341h-1.64q-.054 0-.054.055v2.321q0 .055.055.055zm8.698-3.52q.054 0 .088.044.044.033.044.088v.847q0 .056-.044.099a.12.12 0 0 1-.088.033h-2.024q-.055 0-.055.055v6.402q0 .056-.044.099a.12.12 0 0 1-.088.033h-1.012a.16.16 0 0 1-.1-.033.16.16 0 0 1-.032-.099v-6.402q0-.055-.055-.055h-1.947a.16.16 0 0 1-.1-.033.16.16 0 0 1-.032-.099v-.847q0-.055.033-.088a.14.14 0 0 1 .099-.044zm.99 7.7q-.075 0-.11-.033-.02-.045.023-.121l2.189-3.663a.055.055 0 0 0 0-.066l-2.19-3.663a1 1 0 0 1-.021-.077q0-.077.11-.077h1.1q.12 0 .165.088l1.606 2.728q.033.066.066 0l1.617-2.728q.044-.088.154-.088h1.1q.077 0 .099.044.033.033-.011.11l-2.19 3.663a.1.1 0 0 0 0 .066l2.19 3.663q.022.066.022.077 0 .077-.11.077h-1.1q-.11 0-.154-.088l-1.617-2.717q-.033-.066-.066 0l-1.617 2.717q-.044.088-.154.088z"
    />
    <path
      fill="#DCDDE6"
      fillRule="evenodd"
      d="M40.154 25.329c.04-.473.06-.71-.02-.927a1.15 1.15 0 0 0-.415-.454c-.218-.118-.475-.118-1.01-.118H26.615c-.515 0-.792 0-.99-.099a1.05 1.05 0 0 1-.416-.414c-.098-.197-.098-.473-.098-1.006V10.28c0-.532 0-.789-.12-1.006a1.15 1.15 0 0 0-.454-.414c-.218-.079-.456-.06-.93-.02-2.455.257-4.83 1.085-6.89 2.466a15 15 0 0 0-5.562 6.765 15.04 15.04 0 0 0-.87 8.699 15.27 15.27 0 0 0 4.137 7.712 15.36 15.36 0 0 0 7.74 4.123c2.929.572 5.977.276 8.729-.868a15.04 15.04 0 0 0 6.79-5.543c1.385-2.051 2.216-4.418 2.473-6.864"
      clipRule="evenodd"
    />
    <path
      fill="#A9AABC"
      fillRule="evenodd"
      d="M43.975 18.524a15.1 15.1 0 0 0-4.355-9.152 15.2 15.2 0 0 0-9.185-4.34c-.475-.04-.713-.059-.93.04-.178.059-.357.236-.456.414-.118.197-.118.473-.118.986v12.052c0 .513 0 .789.099.986q.148.267.415.414c.198.1.456.1.99.1H42.53c.514 0 .791 0 .99-.12.177-.098.336-.275.415-.453.099-.217.08-.454.04-.927"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgCompressPowerpoint;
